export default "__VITE_ASSET__DCFD6LDM__"